/*
 * @Author: yangxu
 * @Description:
 * @Date: 2023-07-19 10:53:39
 * @LastEditTime: 2025-03-13 09:39:34
 * @FilePath: /js_zuhe-2023_src/src/store/index.ts
 */
import { createStore } from "vuex";
export default createStore({
  state: {
    detail: [],
    infos: {},
    fdyk: [],
  },
  mutations: {
    /**
     * @description: 总详情数据
     * @param {*} state
     * @param {*} value
     * @return {*}
     */
    setDetail(state, value) {
      state.detail = value;
    },

    /**
     * @description: 示范账户策略信息
     * @param {*} state
     * @param {*} value
     * @return {*}
     */
    setInfos(state, value) {
      state.infos = value;
    },
    /**
     * @description: 设置浮动盈亏
     * @param {*} state
     * @param {*} value
     * @return {*}
     */
    setFdyk(state, value) {
      state.fdyk = value;
    },
  },
  actions: {
    /**
     * @description: 总详情数据
     * @param {*} context
     * @param {*} value
     * @return {*}
     */
    setDetail(context, value) {
      context.commit("setDetail", value);
    },

    /**
     * @description: 示范账户策略信息
     * @param {*} context
     * @param {*} value
     * @return {*}
     */
    setInfos(context, value) {
      context.commit("setInfos", value);
    },
    /**
     * @description: 设置浮动盈亏
     * @param {*} context
     * @param {*} value
     * @return {*}
     */
    setFdyk(context, value) {
      context.commit("setFdyk", value);
    },
  },
  modules: {},
});
